import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider } from "@/context/AuthContext";
import { captureUtm } from "@/utils/utm";
import { fetchContent } from "@/lib/api";
import { applyContent } from "@/lib/content";
import MetaPixel from "@/components/MetaPixel";
import Home from "@/pages/Home";
import Pilote from "@/pages/Pilote";
import Commande from "@/pages/Commande";
import Upsell from "@/pages/Upsell";
import Merci from "@/pages/Merci";
import Audit from "@/pages/Audit";
import CercleFondateurs from "@/pages/CercleFondateurs";
import Compteur from "@/pages/Compteur";
import Demonstration from "@/pages/Demonstration";
import Affiliation from "@/pages/Affiliation";
import Agences from "@/pages/Agences";
import Prix from "@/pages/Prix";
import NotFound from "@/pages/NotFound";
import Angle from "@/pages/Angle";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import AdLanding from "@/pages/AdLanding";
import Journal from "@/pages/Journal";
import Article from "@/pages/Article";

function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    captureUtm();
    fetchContent()
      .then((data) => applyContent(data))
      .catch(() => {})
      .finally(() => setReady(true));
  }, []);

  if (!ready) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#0B0D10", color: "#fff", fontFamily: "sans-serif" }}>
        <span style={{ opacity: 0.6, fontSize: "0.9rem" }}>VIRALYA…</span>
      </div>
    );
  }

  return (
    <HelmetProvider>
      <ThemeProvider>
        <AuthProvider>
          <div className="App">
            <BrowserRouter>
              <MetaPixel />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/pilote" element={<Pilote />} />
                <Route path="/commande/pilote" element={<Commande />} />
                <Route path="/commande" element={<Navigate to="/commande/pilote" replace />} />
                <Route path="/upsell/programme-lancement" element={<Upsell />} />
                <Route path="/merci/pilote" element={<Merci />} />
                <Route path="/merci" element={<Navigate to="/merci/pilote" replace />} />
                <Route path="/audit" element={<Audit />} />
                <Route path="/cercle-fondateurs" element={<CercleFondateurs />} />
                <Route path="/compteur" element={<Compteur />} />
                <Route path="/demonstration" element={<Demonstration />} />
                <Route path="/affiliation" element={<Affiliation />} />
                <Route path="/affiliation/candidature" element={<Affiliation />} />
                <Route path="/agences" element={<Agences />} />
                <Route path="/prix" element={<Prix />} />
                <Route path="/o/:slug" element={<Angle />} />
                <Route path="/journal" element={<Journal />} />
                <Route path="/journal/:slug" element={<Article />} />
                <Route path="/lp/:slug" element={<AdLanding />} />
                <Route path="/legal/:doc" element={<Legal />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </div>
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
